"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var withStyles_1 = require("../styles/withStyles");

var createStyles_1 = require("../styles/createStyles");

var returnAutocompleteOptions_1 = __importDefault(require("./returnAutocompleteOptions"));

var __1 = require("..");

var util_1 = require("../styles/util");

var core_1 = require("@material-ui/core");

var styles = function styles() {
  return createStyles_1.createStyles({
    listbox: {
      backgroundColor: 'transparent',
      '& li': {
        display: 'block'
      }
    }
  });
};

var Autocomplete = React.forwardRef(function (_a, ref) {
  var _inputProps;

  var classes = _a.classes,
      options = _a.options,
      label = _a.label,
      id = _a.id,
      variant = _a.variant,
      onChange = _a.onChange,
      _a$maxListHeight = _a.maxListHeight,
      maxListHeight = _a$maxListHeight === void 0 ? '10rem' : _a$maxListHeight,
      _a$minCharacters = _a.minCharacters,
      minCharacters = _a$minCharacters === void 0 ? 3 : _a$minCharacters,
      optionsFilter = _a.optionsFilter,
      optionDisplayFieldKeys = _a.optionDisplayFieldKeys,
      padding = _a.padding,
      margin = _a.margin,
      value = _a.value,
      fullWidth = _a.fullWidth,
      textfieldProps = __rest(_a, ["classes", "options", "label", "id", "variant", "onChange", "maxListHeight", "minCharacters", "optionsFilter", "optionDisplayFieldKeys", "padding", "margin", "value", "fullWidth"]);

  var _React$useState = React.useState(value || ''),
      inputValue = _React$useState[0],
      setInputValue = _React$useState[1];

  var _React$useState2 = React.useState(''),
      selectedOption = _React$useState2[0],
      setSelectedOption = _React$useState2[1];

  var _React$useState3 = React.useState(undefined),
      selectedOptionId = _React$useState3[0],
      setSelectedOptionId = _React$useState3[1];

  var _React$useState4 = React.useState(undefined),
      selectedOptionIndex = _React$useState4[0],
      setSelectedOptionIndex = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      openOnFocus = _React$useState5[0],
      setOpenOnFocus = _React$useState5[1];

  var _React$useState6 = React.useState(false),
      listOpen = _React$useState6[0],
      setListOpen = _React$useState6[1];

  var _React$useState7 = React.useState([]),
      listOptions = _React$useState7[0],
      setListOptions = _React$useState7[1];

  var _React$useState8 = React.useState(null),
      anchorEl = _React$useState8[0],
      setAnchorEl = _React$useState8[1];

  var _React$useState9 = React.useState(''),
      menuWidth = _React$useState9[0],
      setMenuWidth = _React$useState9[1];

  var _React$useState10 = React.useState(''),
      liveResults = _React$useState10[0],
      setLiveResults = _React$useState10[1];

  var autocompleteRef = React.createRef();
  var listboxRef = React.createRef();
  var optionsTypeObject = typeof options[0] !== 'string';
  var fieldVariant = variant || 'outlined';
  var listboxID = id + "-listbox";
  var fieldClasses = clsx_1.default(util_1.createPaddingClassNames({
    padding: padding
  }), util_1.createMarginClassNames({
    margin: margin
  }));
  React.useEffect(function () {
    var width = autocompleteRef.current ? autocompleteRef.current.offsetWidth + "px" : '200px';
    setMenuWidth(width);
    var timeoutId;

    var resizeListener = function resizeListener() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        var newWidth = anchorEl ? anchorEl.offsetWidth + "px" : '200px';
        setMenuWidth(newWidth);
      }, 150);
    };

    window.addEventListener('resize', resizeListener);
    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, [anchorEl]);
  React.useEffect(function () {
    setListOptions(options);
  }, [options]);

  var handleClose = function handleClose() {
    if (!listOpen) {
      return;
    }

    setListOpen(false);
  };

  var handleOpen = function handleOpen() {
    if (listOpen) {
      return;
    }

    setListOpen(true);
  };

  var handleValue = function handleValue(event, newValue, trigger) {
    if (inputValue === newValue) {
      return;
    }

    setInputValue(newValue);

    if (trigger === 'onChange' || trigger === 'enter' || trigger === 'click') {
      handleListResults(event, newValue, event.currentTarget);
    }

    if (onChange) {
      onChange(event, newValue);
    }
  };

  var handleReset = function handleReset(event, resetValue) {
    if (resetValue) {
      handleValue(event, '', 'reset');
    }

    setListOptions([]);
    setSelectedOption('');
    setSelectedOptionIndex(undefined);
    setSelectedOptionId(undefined);
    setLiveResults('');
    handleClose();
  };

  var handleAriaLive = function handleAriaLive(listResults) {
    var resultText = listResults === 1 ? 'result' : 'results';
    setLiveResults(listResults + " " + resultText + " available.");
  };

  var handleListResults = function handleListResults(event, newValue, target) {
    if (newValue.length >= minCharacters) {
      var autocompleteOptions = optionsFilter ? optionsFilter(options, newValue) : returnAutocompleteOptions_1.default(options, newValue, optionDisplayFieldKeys);
      var listResults = autocompleteOptions && autocompleteOptions.length;

      if (listResults) {
        setListOptions(autocompleteOptions);

        if (!anchorEl) {
          setAnchorEl(target);
        }

        handleOpen();
        handleAriaLive(listResults);
      } else {
        handleReset(event, false);
      }
    } else {
      handleReset(event, false);
    }
  };

  var handleListNavigationScroll = function handleListNavigationScroll(listbox, index, option) {
    var menu = listbox.closest('div');
    var menuHeight = menu.clientHeight;

    if (index === 0) {
      menu.scrollTop = 0;
      return;
    }

    if (listbox.scrollHeight > menuHeight) {
      var scrollBottom = menuHeight + menu.scrollTop;
      var optionBottom = option.offsetTop + option.offsetHeight;

      if (optionBottom > scrollBottom) {
        menu.scrollTop = optionBottom - menuHeight + 4;
      } else if (option.offsetTop - option.offsetHeight < menu.scrollTop) {
        menu.scrollTop = option.offsetTop - option.offsetHeight;
      }
    }
  };

  var handleListNavigation = function handleListNavigation(_ref) {
    var direction = _ref.direction;
    setOpenOnFocus(false);
    var listbox = listboxRef.current ? listboxRef.current : false;

    if (listbox) {
      var index;
      var length = listOptions.length - 1;
      var currIndex = selectedOptionIndex || 0;

      switch (direction) {
        case 'previous':
          index = currIndex > 0 ? currIndex - 1 : length;
          break;

        case 'next':
          if (!selectedOption) {
            index = 0;
          } else {
            index = currIndex < length ? currIndex + 1 : 0;
          }

          break;
      }

      setSelectedOptionIndex(index);
      setSelectedOptionId(id + "-option-" + index);
      var option = listbox.querySelector("li:nth-child(" + (index + 1) + ")");
      var valueElem = optionsTypeObject ? option === null || option === void 0 ? void 0 : option.querySelector(':first-child') : option;
      var newValue = valueElem === null || valueElem === void 0 ? void 0 : valueElem.textContent;
      setSelectedOption(newValue || '');
      handleListNavigationScroll(listbox, index, option);
    }
  };

  var handleOnChange = function handleOnChange(event) {
    var newValue = event.target.value;

    if (inputValue === newValue) {
      return;
    }

    if (newValue.length) {
      handleValue(event, newValue, 'onChange');
    } else {
      handleReset(event, true);
    }
  };

  var handleOnInputInteraction = function handleOnInputInteraction(event) {
    if (openOnFocus || event.type === 'click') {
      var newValue = event.target.value;

      if (!anchorEl) {
        setAnchorEl(event.target);
      }

      if (newValue.length >= minCharacters) {
        var autocompleteOptions = returnAutocompleteOptions_1.default(options, newValue);
        var listResults = autocompleteOptions.length;

        if (listResults && anchorEl) {
          setListOptions(autocompleteOptions);
          handleAriaLive(listResults);
          setTimeout(function () {
            setListOpen(true);
          }, 0);
        }
      }
    }

    setOpenOnFocus(false);
  };

  var handleUpdateSelectedOption = function handleUpdateSelectedOption(event, newValue, index, key) {
    if (inputValue === newValue) {
      return;
    }

    handleValue(event, newValue, key);
    setSelectedOption(newValue);
    setSelectedOptionIndex(index);
    setLiveResults('');
  };

  var handleSelectOption = function handleSelectOption(event, index) {
    var _a, _b;

    var valueElem = optionsTypeObject ? event.currentTarget.querySelector(':first-child') : event.currentTarget;
    var newValue = (valueElem === null || valueElem === void 0 ? void 0 : valueElem.textContent) || '';
    handleUpdateSelectedOption(event, newValue, index, 'click');
    setSelectedOptionId(id + "-option-" + index);
    (_b = (_a = autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) === null || _b === void 0 ? void 0 : _b.focus();
    handleClose();
  };

  var handleSelectCurrentOption = function handleSelectCurrentOption(event, key) {
    if (typeof selectedOptionIndex === 'number') {
      var newValue = selectedOption;

      if (selectedOption === '') {
        var listbox = listboxRef.current ? listboxRef.current : false;
        var currOption = listbox ? listbox.querySelector("li:nth-child(1)") : false;

        if (listbox && currOption) {
          newValue = currOption.textContent ? currOption.textContent : '';
        }
      }

      handleUpdateSelectedOption(event, newValue, selectedOptionIndex || 0, key);
    }

    handleClose();
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case 'Tab':
        if (listOpen) {
          handleSelectCurrentOption(event, 'tab');
        }

        setOpenOnFocus(true);
        setSelectedOptionId(undefined);
        handleClose();
        break;

      case 'ArrowDown':
        event.preventDefault();
        handleListNavigation({
          direction: 'next'
        });
        break;

      case 'ArrowUp':
        event.preventDefault();
        handleListNavigation({
          direction: 'previous'
        });
        break;

      case 'Enter':
        if (event.which === 229) {
          break;
        }

        if (listOpen) {
          event.preventDefault();
          handleSelectCurrentOption(event, 'enter');
        }

        break;

      case 'Escape':
        if (listOpen) {
          event.preventDefault();
          event.stopPropagation();
          handleReset(event, true);
        }

        break;
    }
  };

  var ariaOwns = listOpen ? listboxID : undefined;
  var ariaActiveDescendent = listOpen ? selectedOptionId : undefined;
  return React.createElement(React.Fragment, null, React.createElement(__1.RootRef, {
    rootRef: autocompleteRef
  }, React.createElement(__1.FormControl, {
    ref: ref,
    role: "combobox",
    "aria-expanded": listOpen,
    "aria-owns": ariaOwns,
    "aria-haspopup": "listbox",
    className: fieldClasses,
    fullWidth: fullWidth
  }, React.createElement(__1.TextField, Object.assign({
    autoComplete: "off",
    autoCapitalize: "none",
    spellCheck: "false",
    variant: fieldVariant,
    fullWidth: fullWidth,
    id: id,
    label: label,
    onChange: handleOnChange,
    onClick: handleOnInputInteraction,
    onFocus: handleOnInputInteraction,
    onKeyDown: handleKeyDown,
    value: inputValue,
    inputProps: (_inputProps = {}, _inputProps['aria-autocomplete'] = 'list', _inputProps['aria-controls'] = listboxID, _inputProps['aria-activedescendant'] = ariaActiveDescendent, _inputProps['autoComplete'] = 'off', _inputProps)
  }, textfieldProps)), React.createElement(__1.Typography, {
    variant: "srOnly",
    "aria-live": "polite",
    role: "status"
  }, liveResults))), React.createElement(core_1.Popper, {
    anchorEl: anchorEl,
    open: listOpen,
    role: "presentation",
    onKeyDown: handleKeyDown,
    disablePortal: true,
    style: {
      zIndex: 10
    }
  }, React.createElement(__1.Paper, {
    style: {
      width: menuWidth,
      maxHeight: maxListHeight,
      overflowY: 'auto',
      scrollBehavior: 'smooth'
    },
    elevation: 1
  }, React.createElement(__1.RootRef, {
    rootRef: listboxRef
  }, React.createElement(__1.ClickAwayListener, {
    onClickAway: handleClose
  }, React.createElement(core_1.MenuList, {
    role: "listbox",
    "aria-labelledby": id + "-label",
    id: listboxID,
    tabIndex: undefined,
    className: classes.listbox
  }, listOpen && listOptions.map(function (option, index) {
    var optionField = optionsTypeObject && optionDisplayFieldKeys ? option[optionDisplayFieldKeys.primary] : option;
    var selected = optionField === selectedOption || index === selectedOptionIndex;
    var optionId = id + "-option-" + index;
    var optionsDisplay = !optionsTypeObject ? option : optionDisplayFieldKeys ? React.createElement(React.Fragment, null, React.createElement(__1.Typography, {
      component: "span",
      variant: "inherit",
      display: "block"
    }, option[optionDisplayFieldKeys.primary]), optionDisplayFieldKeys.secondary && option[optionDisplayFieldKeys.secondary] && React.createElement(__1.Typography, {
      component: "span",
      variant: "caption",
      color: "textSecondary",
      display: "block"
    }, option[optionDisplayFieldKeys.secondary])) : null;
    return React.createElement(core_1.MenuItem, {
      key: optionField,
      id: optionId,
      role: "option",
      onClick: function onClick(e) {
        return handleSelectOption(e, index);
      },
      selected: selected,
      "aria-selected": selected,
      tabIndex: 0
    }, optionsDisplay);
  })))))));
});
exports.default = withStyles_1.withStyles(styles, {
  name: 'UnifiAutocomplete'
})(Autocomplete);